import storeModuleType from './types/storeModule'

import { Root } from '@/model/root'
import { Data } from "@/data/data"
import { PageTransition } from '@/pageTransition/pageTransition';
import { CloudOperation } from '@/cloudOperation/cloudOperation';
import { UserConfigColors } from '@/userConfigColors/userConfigColors';
import { InsertionCombination } from '@/insertionCombination/insertionCombination';
import { CloudAccount } from "@/cloudAccount/cloudAccount";
import { SnsInfo } from "@/snsInfo/snsInfo";

// import { editModule } from '@/views/edit/storeModule/editModule'

export const StoreModule = {
    state: {
        root : new Root(),
        // data : new Data(),
        data : new Data(),
        pageTransition : new PageTransition(),
        cloudOperation : new CloudOperation(),
        userConfigColors : new UserConfigColors(),
        insertionCombination : new InsertionCombination(),
        isSplashEnded: false,
        cloudAccount: new CloudAccount(),
        openingFile: null,
        fontLoaded: false,
        snsInfo : new SnsInfo(),
    },
    mutations : {
        stopSplash(state) {
            state.isSplashEnded = true;
        }
    },
    actions: {
        setDocument(storeModule , document){
            storeModule.state.root.document = document
        },
        // updateData(storeModule){
        //   storeModule.state.data = new Data()
        // }
        changeEditMode(storeModule , editMode : number){
            storeModule.state.root.applicationState.editMode = editMode;
        },
        changeInputMode(storeModule , inputMode : number){
            storeModule.state.root.applicationState.inputMode = inputMode;
        },
        setPageTransition(storeModule , page : string){
            storeModule.state.pageTransition.page = page;
        },
        setCloudOperation(storeModule , page : string){
            storeModule.state.cloudOperation.returnPage = page;
        },
        setCloudMode(storeModule , mode : string){
            storeModule.state.cloudOperation.mode = mode;
        },
        promiseToOpenDocument(store, file: {path: string, data: any}) {
            // ファイルを開けるように持っておく
            store.state.openingFile = file;
        },
        // setSnsType(storeModule , snsType : number){
        //     storeModule.state.snsInfo.selectSnsType = snsType;
        // },
        setSignInToGo(storeModule , toGo : string){
            storeModule.state.cloudAccount.toGo = toGo;
        }
    },
    getters: {
        root : state => { return state.root },
        document : state => { return state.root.document },
        //design : state => { return state.root.document.pageList[0].designList[0] }
        design : state =>
        {
            var document = state.root.document;
            var page = document.pageList[document.currentPageIndex];
            var design = page.getSurface(document.isReverseSurface).getDesign(page.currentDesignPosition);
            return design;
        },
        data : state => { return state.data },
        messageCenter : state => { return state.root.messageCenter; },
        applicationState : state => { return state.root.applicationState; },
        userConfig : state => {return state.root.userConfig; },
        pageTransition : state => { return state.pageTransition; },
        cloudOperation : state => { return state.cloudOperation; },
        fontManager : state => { return state.root.fontManager; },
        shortcutManager : state => { return state.root.shortcutManager; },
        clipboardManager : state => { return state.root.clipboardManager; },
        userConfigColors : state => { return state.userConfigColors; },
        insertionCombination : state => { return state.insertionCombination; },
        cloudAccount : state => { return state.cloudAccount; },
        snsInfo : state => { return state.snsInfo; },
        dataContainer : state => { return state.root.dataContainer; },
    },
    // modules:{
    //   edit : editModule
    // }
}
